import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Tables } from '../../entities/tables';
import { FormFieldConfig } from '../dynamic-component-shared/dropdown/form_field_config';
import { UserService } from 'src/app/admin/core/services/user.service';
import { FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { catchError, map } from 'rxjs/operators';
import { Subscription, of } from 'rxjs';
import {
  debounceTime,
  tap,
  switchMap,
  finalize,
  distinctUntilChanged,
  filter,
} from 'rxjs/operators';
import { Language } from '../../entities/language';
import { TableService } from '../../services/table.service';
import { TabService } from '../../services/tab.service';
import { DiaologHostComponent } from '../dialogs/dialog-host/dialog-host';
import { MatDialog } from '@angular/material/dialog';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { DeleteReq } from '../../entities/deleteReq';

@Component({
  selector: 'app-backoffice-menu',
  templateUrl: './backoffice-menu.component.html',
  styleUrls: ['./backoffice-menu.component.css'],
})
export class BackofficeMenuComponent implements OnInit {
  edition: boolean = true;
  lecture: boolean = false;
  config: FormFieldConfig;
  @Input() public tab: Tables = new Tables();
  @Input() public menuName: any;
  @Input() public value: any;
  deleteReq: DeleteReq = new DeleteReq();
  @Input() public editMode: boolean;
  tempMenuObj: any;
  entite: any;
  menuObj: any = {};
  isWholeEntite = false;
  entiteRelationProperte: any;
  filteredDocumentInfo: any[] = [];
  filteredMenu: any[] = [];
  typeName: any;
  totalElements: Number;

  selectedIcon: any;
  private subscription: Subscription | undefined;
  minLengthTerm = 1;
  pageIndex: number = 1;
  pageSize: number = 10;
  filsduMenu: any;
  parentMenu: any;
  searchedParent: any;
  searchedEntite: any;
  selectedFils: any;
  languages: Language[] = [];
  searchDocumentInfoCtrl = new FormControl();
  searchMenuCtrl = new FormControl();
  icons: string[] = [
    'surface1',
    'arborescence',
    'pers morale_blc',
    'sharing',
    'deconnexion',
    'accueil',
  ];
  constructor(
    public userService: UserService,
    private httpClient: HttpClient,
    private httpclientService: HttpclientService,
    private tableService: TabService,
    private dash: DashboardComponent,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getMenuFils();
    // if (this.menuName == 'edition') {

    this.entite = 'menu';
    //}

    if (this.tab?.value === 'edition') {
      this.modeEdition();
    } else if (this.tab?.value === 'lecture') {
      this.edition = false;
      this.lecture = true;
      let subs = this.httpclientService
        .getObjet(this.tab.entite, this.tab.id)
        .subscribe((res: any) => {
          this.menuObj = res;
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config.id = '4';
      this.config = changes['config'].currentValue;
      this.typeName = this.config.typeName;
      this.searchMenuCtrl.setValue(this.menuObj.parentId);
      this.searchDocumentInfoCtrl.setValue(this.menuObj.entityName);
    }
  }

  modeEdition() {
    this.tempMenuObj = this.menuObj;
    this.edition = true;
    this.lecture = false;
    this.searchMenuCtrl.setValue(this.menuObj.parentId);
    this.searchDocumentInfoCtrl.setValue(this.menuObj.entityName);
  }

  getMenuFils() {
    const menuUrl = `menu/`;

    if (this.subscription) {
      this.subscription.unsubscribe(); // Unsubscribe previous subscription
    }

    this.subscription = this.httpClient
      .get<any[]>(menuUrl)
      .pipe(
        catchError((error) => {
          console.error('Error fetching menu:', error);
          return of([]);
        }),
        map((items) => items.filter((item) => item.text !== this.menuObj.text))
      )
      .subscribe((filteredItems) => {
        this.selectedFils = filteredItems;
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe(); // Unsubscribe when component is destroyed
    }
  }

  enregistrer() {
    let menuUrl = 'menu/add';
    // this.menuObj.text = this.menuName;
    // this.menuObj.children = this.filsduMenu;
    this.menuObj.parentId = this.searchMenuCtrl.getRawValue();
    this.menuObj.entityName = this.searchDocumentInfoCtrl.getRawValue();
    this.menuObj.droitTitle = this.menuObj.text;
    this.menuObj.selected = true;
    this.menuObj.is_custom_icon = true;
    this.menuObj.isDynamic = true;

    this.subscription = this.httpClient
      .post(menuUrl, this.menuObj)
      .pipe(
        catchError((error) => {
          console.error('Error fetching menu:', error);
          return of({});
        })
      )
      .subscribe((savedMenu) => {
        this.menuObj = savedMenu;
        this.dash.changeNameOrTitleAfterSave(
          this.tab,
          this.tableService.getTabTitle(
            this.menuObj,
            this.languages,
            this.entite
          )
        );
        this.tableService.updateOrAddItem(this.menuObj, this.tab.entite);
      });

    this.lecture = true;
    this.edition = false;
    this.tab.value = 'lecture';
    this.tab.dialogName = 'popup';

    if (!this.menuObj.id) {
      this.tab.msg = `Un nouveau menu  a été créé avec le nom :  ${this.menuObj?.text}`;
    } else {
      this.tab.msg = 'Vos modifications ont été enregistrées avec succès';
    }
    let dialogRef = this.dialog.open(DiaologHostComponent, {
      panelClass: 'filtre-dialog-component',
      data: {
        title: 'Attention !',
        msg: this.tab.msg,
        tab: this.tab,
      },
    });
  }

  rafraichir() {
    this.tempMenuObj = this.menuObj;
    this.menuObj = {};
  }

  annuler() {
    this.lecture = true;
    this.edition = false;
    this.menuObj = this.tempMenuObj;
  }

  compareValeurs(o1: any, o2: any): boolean {
    if (o1 && o2) {
      return o1.id === o2.id;
    }
    return false;
  }

  suppressiondemasse() {
    this.deleteReq.idList.push(this.tab.id);

    this.totalElements = this.tab.totalElements;
    this.tab.dialogName = 'supprime';
    this.tab.deleteReq = this.deleteReq;

    this.tab.msg = `Voulez-vous vraiment supprimer les enregistrements`;
    let dialogRef = this.dialog.open(DiaologHostComponent, {
      panelClass: 'filtre-dialog-component',
      data: {
        title: 'Confirmation de la suppression',
        msg: `Voulez-vous vraiment supprimer les enregistrements`,
        tab: this.tab,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dash.openPrev(this.tab);
    });
  }
  autocompleteSearchDocumentInfo(event: any) {
    this.searchDocumentInfoCtrl.valueChanges
      .pipe(
        filter((res) => {
          return (
            res !== null &&
            res !== undefined &&
            res.length >= this.minLengthTerm
          );
        }),
        distinctUntilChanged(),
        debounceTime(100),
        tap(() => {
          this.filteredDocumentInfo = [];
        }),
        switchMap((value) =>
          this.httpClient.get(
            `view/autocomplete?entite=DynamicDocumentInfo&q=${value}&page=${this.pageIndex}&size=${this.pageSize}`
          )
        )
      )
      .subscribe((res: any) => {
        this.filteredDocumentInfo = res.content;
      });
  }

  autocompleteSearchMenu(event: any) {
    this.searchMenuCtrl.valueChanges
      .pipe(
        filter((res) => {
          return (
            res !== null &&
            res !== undefined &&
            res.length >= this.minLengthTerm
          );
        }),
        distinctUntilChanged(),
        debounceTime(100),
        tap(() => {
          this.filteredMenu = [];
        }),
        switchMap((value) =>
          this.httpClient.get(
            `view/autocomplete?entite=Menu&q=${value}&page=${this.pageIndex}&size=${this.pageSize}`
          )
        )
      )
      .subscribe((res: any) => {
        this.filteredMenu = res.content;
      });
  }

  onAutocompleteOptionMenuSelected(menu: any) {
    this.searchedParent = menu;
    this.searchMenuCtrl.setValue(menu.text);
  }

  onAutocompleteOptionDocumentInfoSelected(entite: any) {
    this.searchedEntite = entite;
    this.searchDocumentInfoCtrl.setValue(entite.documentName);
  }

  ouvrirOnglet(data: any) {
    let nom = data[this.config.searchableFields[0]];

    this.dash.visualisation(
      nom,
      this.entite,
      `${data.id}`,
      '',
      100,
      this.config.typeName
    );
  }
}
